import { render, staticRenderFns } from "./DriverApplications.vue?vue&type=template&id=5f5a597c&"
import script from "./DriverApplications.vue?vue&type=script&lang=js&"
export * from "./DriverApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports